import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import logo from '../images/logo_bezh.png';
import CurrentUserContext from '../contexts/CurrentUserContext';
import { CartContext } from '../contexts/cardContext';
import basket from '../images/basket1.PNG';
import icon from '../images/icon.png';
import { BASE_URL } from '../utils/config';
import PopupLogin from './PopupLogin';
import PopupRegistration from './PopupRegistration';
import PopupConsent from './PopupConsent';
import PopupUserProfile from './PopupUserProfile';
import PopupOrderHistory from './PopupOrderHistory';
import PopupCart from './PopupCart';
import PopupOrderSuccess from './PopupOrderSuccess';

function Header({ onOpenFeedback }) {
  const { user, setUser } = useContext(CurrentUserContext);
  const { cart, totalPrice, clearCart, increaseItemAmount, decreaseItemAmount, removeItem, pizzaBoxes } = useContext(CartContext);
  const [currentTime, setCurrentTime] = useState('');
  const [showRegistrationPopup, setShowRegistrationPopup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showCartPopup, setShowCartPopup] = useState(false);
  const [showUserProfilePopup, setShowUserProfilePopup] = useState(false);
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [cities, setCities] = useState([]);
  const [allStreets, setAllStreets] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [filteredStreets, setFilteredStreets] = useState([]);
  const [showStreetDropdown, setShowStreetDropdown] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const { getProductByName } = useContext(CartContext);
  const [showOrderSuccessPopup, setShowOrderSuccessPopup] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showOrderHistoryPopup, setShowOrderHistoryPopup] = useState(false);
  const [orderHistory, setOrderHistory] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [orderError, setOrderError] = useState('');
  const [addressData, setAddressData] = useState({
    city: '',
    street: '',
    house: '',
    building: '',
    entrance: '',
    floor: '',
    flat: '',
    comment: ''
  });
  const [formData, setFormData] = useState({
    fullName: '',
    surname:'',
    name: '',
    middleName: '',
    birthday: '',
    phoneNumber: '',
    email: '',
    walletBalances: '',
    consentStatus: '',
    sex: ''
  });
  const [cartData, setCartData] = useState(
    cart.map(product => ({ ...product, amount: 1, comment: '', guests: 1, image: '' }))
  );

  useEffect(() => { // РЕГИСТРАЦИЯ
    if (showRegistrationPopup) {
      const fetchUserData = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/loyalty/iiko/customer/get`);
          setFormData(response.data);
        } catch (error) {
          console.error('Ошибка загрузки данных пользователя:', error);
        }
      };
      fetchUserData();
    }
  }, [showRegistrationPopup]);

  useEffect(() => {
    if (showRegistrationPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showRegistrationPopup]);

  const updateFormData = (user) => ({
    fullName: `${user?.surname || ''} ${user?.name || ''} ${user?.middleName || ''}`.trim(),
    birthday: user?.birthday || '',
    phoneNumber: user?.phoneNumber || '',
    email: user?.email || '',
    walletBalances: user?.walletBalances || [],
    consentStatus: '',
    sex: user?.sex?.toString() || '',
  });
  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      setFormData(updateFormData(storedUser));
    }
  }, [setUser]);
  
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
      setFormData(updateFormData(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  useEffect(() => { // ВРЕМЯ
    const updateCurrentTime = () => {
      const daysOfWeek = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
      const today = new Date().getDay();
      const hours = new Date().getHours();
      const minutes = new Date().getMinutes();
      const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
      let workingHours = '22:30';
      if (today === 5 || today === 6) {
        workingHours = '23:30';
      }
      setCurrentTime(`${daysOfWeek[today]} ${formattedTime}\nПринимаем заказы с 10:00 до ${workingHours}`);
    };
    updateCurrentTime();
    const intervalId = setInterval(updateCurrentTime, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => { // КОРЗИНА
    setCartData(cart.map(product => ({
      productId: product.productId,
      name: product.name,
      image: product.image,
      price: product.price,
      amount: product.amount || 1,
      modifiers: product.modifiers || [],
      guests: product.guests || 1,
      comment: product.comment || ''
    })));
  }, [cart]);

  useEffect(() => { // СПИСОК ГОРОДОВ
    const fetchCities = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/cities`);
        const cityItems = response.data.cities[0].items;
        setCities(cityItems);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities();
  }, [showAddressForm]);

  const openLoginPopup = () => {
    setShowLoginPopup(true);
    setShowRegistrationPopup(false);
    setShowCartPopup(false)
  }
  const openRegistrationPopup = () => {
    setShowRegistrationPopup(true);
    setShowLoginPopup(false);
  };
  const openCartPopup = () => {
    setShowCartPopup(true);
  };

  const openUserProfilePopup = () => {
    setFormData({
      fullName: `${user?.surname || ''} ${user?.name || ''} ${user?.middleName || ''}`.trim(),
      birthday: user?.birthday ? getDateWithoutTime(user.birthday) : '',
      phoneNumber: user?.phoneNumber || '',
      email: user?.email || '',
      walletBalances: user.walletBalances || []
    });
    setShowUserProfilePopup(true);
    setShowRegistrationPopup(false);
    setShowLoginPopup(false);
    setShowCartPopup(false);
    setShowOrderHistoryPopup(false);
  };

  const openConsentPopup = () => {
    setShowConsentPopup(true);
  };

  const toggleUserMenu = () => {
    setShowUserMenu((prev) => {
        if (!prev) {
            return true;
        }
        return !prev;
    });
  };
  
  const openOrderHistoryPopup = () => {
    console.log("Попап истории заказов открыт");
    setShowOrderHistoryPopup(true);
    setShowUserProfilePopup(false);
    fetchOrderHistory();
  };
  
  const closeOrderHistoryPopup = () => {
    setShowOrderHistoryPopup(false);
  };

  const closePopups = () => {
    setShowRegistrationPopup(false);
    setShowLoginPopup(false);
    setShowCartPopup(false);
    setShowUserProfilePopup(false);
    setShowConsentPopup(false);
    setErrorMessage('');
    setVerificationCode('');
    setMaskedEmail('');
    setIsCodeSent(false);
    setShowCodeInput(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "sex") {
      setFormData((prevState) => ({
        ...prevState,
        sex: value
      }));
      return;
    }
    if (name === "phoneNumber") {
      let formattedValue = value;
      if (formattedValue === "+7") {
      } else if (formattedValue.startsWith("+") && formattedValue[1] !== "7") {
        formattedValue = "+7" + formattedValue.slice(1);
      } else if (formattedValue === "7") {
        formattedValue = "+7";
      } else if (formattedValue === "8") {
        formattedValue = "+7";
      } else if (formattedValue === "9" || formattedValue.startsWith("9")) {
        formattedValue = "+7" + formattedValue;
      } else if (!formattedValue.startsWith("+7") && !formattedValue.startsWith("+") && !formattedValue.startsWith("9") && formattedValue !== "8") {
        formattedValue = "+7" + formattedValue;
      }
      setFormData((prevState) => ({
        ...prevState,
        [name]: formattedValue
      }));
      return;
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const sendVerificationCode = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/auth/request-code`, {
        phone: formData.phoneNumber
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      const { status } = response.data;

      if (status === "code_sent") {
        setIsCodeSent(true);
        setShowCodeInput(true);
        setMaskedEmail(response.data.maskedEmail || '');
        startTimer();
      } else if (status === "registration_required") {
        setMaskedEmail('');
        openRegistrationPopup();
      } else if (status === "email_required") {
        setMaskedEmail('');
        openRegistrationPopup();
      }

      return status;
    } catch (error) {
      setErrorMessage("Ошибка при отправке кода");
      setMaskedEmail('');
      return null;
    }
  };

  const startTimer = () => {
    setTimer(600);
    timerInterval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval);
          setShowCodeInput(false);
          return 600;
        }
        return prev - 1;
      });
    }, 1000);
  };
  let timerInterval;

  const fetchOrderHistory = async () => {
    if (!user?.phoneNumber) {
      setOrderError("Необходимо войти в аккаунт");
      return;
    }
  
    console.log("Запрос на историю заказов отправлен...");
    setLoadingOrders(true);
    setOrderError("");
  
    try {
      const response = await axios.post(`${BASE_URL}/deliveries/by_delivery_date_and_phone`, {
        phone: user.phoneNumber
      });
  
      console.log("Ответ от сервера:", response.data);
  
      const orders = response.data.ordersByOrganizations?.[0]?.orders || [];
  
      const filteredOrders = orders.filter(order => order.order !== null);
  
      setOrderHistory(filteredOrders);
    } catch (error) {
      console.error("Ошибка загрузки истории заказов:", error);
      setOrderError("Не удалось загрузить заказы");
    } finally {
      setLoadingOrders(false);
    }
  };

  const handleOrderSubmit = async (event) => {
    event.preventDefault();
  if (!addressData.city || !addressData.street || !addressData.house) {
    alert("Пожалуйста, заполните все обязательные поля (город, улица, дом).");
    return;
  }
  if (cart.length === 0) {
    alert("Корзина пуста! Добавьте хотя бы один товар в корзину.");
    return;
  }
    const items = cartData.map(item => ({
      type: 'Product',
      amount: item.amount || 1,
      productId: item.productId,
      modifiers: (item.modifiers || []).map(mod => ({
        productId: mod.productId,
        amount: mod.amount || 1,
        productGroupId: mod.productGroupId || '',
      })),
      comment: item.comment || ''
    }));
    if (pizzaBoxes.pizzaBox30 && pizzaBoxes.pizzaBox30.amount > 0) {
      items.push({
        type: 'Product',
        amount: pizzaBoxes.pizzaBox30.amount,
        productId: pizzaBoxes.pizzaBox30.id,
        productGroupId: pizzaBoxes.pizzaBox30.productGroupId || '',
        comment: 'коробка для пиццы 30 см'
      });
    }
    if (pizzaBoxes.pizzaBox40 && pizzaBoxes.pizzaBox40.amount > 0) {
      items.push({
        type: 'Product',
        amount: pizzaBoxes.pizzaBox40.amount,
        productId: pizzaBoxes.pizzaBox40.id,
        productGroupId: pizzaBoxes.pizzaBox40.productGroupId || '',
        comment: 'коробка для пиццы 40 см'
      });
    }
    const orderData = {
      phone: formData.phoneNumber,
      email: formData.email || user?.email || '',
      comment: addressData.comment || '',
      guests: formData.guests || 1,
      items: items,
      address: {
        street: { id: addressData.street.id },
        house: addressData.house,
        building: addressData.building || '',
        flat: addressData.flat || '',
        entrance: addressData.entrance || '',
        floor: addressData.floor || '',
        doorphone: addressData.doorphone || ''
      },
      customer: {
        id: user?.id || '',
        type: 'regular',
        surname: user?.surname || '',
        name: user?.name || formData.name || '',
        middleName: user?.middleName || '',
        birthday: user?.birthday || formData.birthday || '',
        email: formData.email || user?.email || ''
      }
    };
    try {
      const response = await axios.post(`${BASE_URL}/deliveries/create`, orderData);
      console.log('Заказ успешно отправлен:', response);
      setShowCartPopup(false);
      clearCart();
      setShowOrderSuccessPopup(true);
    } catch (error) {
      console.error('Ошибка при отправке заказа:', error);
    }
  };

  const handleStreetSearch = async (cityId, query) => {
    if (!cityId) {
      console.error("City ID is required but not provided.");
      return;
    }
    try {
      const response = await axios.post(`${BASE_URL}/streets/by_city`, {
        id: cityId,
        name: query || '',
      });
      const streetItems = response.data.streets;
      setAllStreets(streetItems);
      setFilteredStreets(streetItems);
    } catch (error) {
      console.error("Error fetching streets:", error);
    }
  };

  const getDateWithoutTime = (dateString) => {
    return format(parseISO(dateString), 'yyyy-MM-dd');
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    sendVerificationCode();
  };

  const verifyCode = async () => {
  try {
    // 1. Проверяем код
    await axios.post(`${BASE_URL}/auth/verify-code`, {
      phone: formData.phoneNumber,
      code: verificationCode
    });

    setErrorMessage('');

    // 2. Получаем информацию о пользователе
    const userInfo = await axios.post(
      `${BASE_URL}/loyalty/iiko/customer/info`,
      { phone: formData.phoneNumber }
    );

    // 3. Если пользователь НЕ найден — открываем регистрацию
    if (userInfo.data.status === "not_found") {
      openRegistrationPopup();
      return;
    }

    // 4. Если пользователь найден и данные заполнены полностью — логиним
    if (
      userInfo.data.surname &&
      userInfo.data.name &&
      userInfo.data.birthday &&
      userInfo.data.consentStatus === 1 &&
      (userInfo.data.sex === 1 || userInfo.data.sex === 2)
    ) {
      setUser({
        ...userInfo.data,
        phoneNumber: formData.phoneNumber
      });

      closePopups();
    } 
    // 5. Если пользователь найден, но данные неполные — отправляем в регистрацию
    else {
      setFormData({
        ...formData,
        ...userInfo.data
      });

      openRegistrationPopup();
    }

  } catch (error) {

    if (error.response) {

      // ❗ Неверный код
      if (error.response.status === 401) {
        setErrorMessage('Введен неверный код. Повторите попытку.');
      } 
      // ❗ Любая другая серверная ошибка
      else {
        setErrorMessage('Произошла ошибка. Повторите попытку позже.');
      }

    } else {
      // ❗ Ошибка сети
      setErrorMessage('Ошибка сети. Проверьте соединение.');
    }
  }
};
  
  const handleUserProfileSubmit = async (e) => {
    e.preventDefault();
    let surname, name, middleName;
    if (formData.fullName) {
      const nameParts = formData.fullName.split(' ');
      surname = nameParts[0] || '';
      name = nameParts[1] || '';
      middleName = nameParts.length > 2 ? nameParts.slice(2).join(' ') : '';
    } else {
      surname = formData.surname || '';
      name = formData.name || '';
      middleName = formData.middleName || '';
    }
    const requestData = {
      phone: formData.phoneNumber,
      name,
      surname,
      middleName: middleName || '',
      birthday: formData.birthday,
      email: formData.email,
      consentStatus: '1',
      sex: formData.sex ? parseInt(formData.sex, 10) : null,
    };
    if (formData.sex) {
      requestData.sex = parseInt(formData.sex, 10);
    }
    try {
      await axios.post(`${BASE_URL}/loyalty/iiko/customer/create_or_update`, requestData);
      const userInfoResponse = await axios.post(`${BASE_URL}/loyalty/iiko/customer/info`, { phone: formData.phoneNumber });
      const updatedUser = { ...userInfoResponse.data, phoneNumber: formData.phoneNumber };

      if (showRegistrationPopup) {
        setFormData({
          ...formData,
          surname: updatedUser.surname || surname,
          name: updatedUser.name || name,
          middleName: updatedUser.middleName || middleName,
          birthday: updatedUser.birthday || formData.birthday,
          phoneNumber: updatedUser.phoneNumber || formData.phoneNumber,
          email: updatedUser.email || formData.email,
          sex: updatedUser.sex?.toString() || formData.sex
        });
        setErrorMessage('');
        setVerificationCode('');
        setShowCodeInput(false);
        openLoginPopup();
        await sendVerificationCode();
      } else {
        setUser(updatedUser);
        setFormData({
          fullName: `${updatedUser.surname || ''} ${updatedUser.name || ''} ${updatedUser.middleName || ''}`.trim(),
          birthday: updatedUser.birthday || '',
          phoneNumber: updatedUser.phoneNumber || '',
          email: updatedUser.email || '',
          sex: updatedUser.sex?.toString() || ''
        });
        closePopups();
      }
    } catch (error) {
      console.error('Error updating user profile:', error);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    closePopups();
    setFormData({
      fullName: '',
      birthday: '',
      phoneNumber: '',
      email: ''
    });
    clearInterval(timerInterval);
    setTimer(60);
    setIsCodeSent(false);
    setShowCodeInput(false);
    setVerificationCode('');
  };

  const handleCityChange = (selectedCity) => {
    setAddressData((prevState) => ({
      ...prevState,
      city: selectedCity,
      street: '',
      house: '',
      building: '',
      entrance: '',
      floor: '',
      flat: '',
      comment: ''
    }));
    setAllStreets([]);
    setFilteredStreets([]);
    setFilterText('');
    setShowStreetDropdown(false);

    if (selectedCity) {
      handleStreetSearch(selectedCity, '');
      updateDeliveryPrice(selectedCity, totalPrice);
    } else {
      setDeliveryPrice(0);
    }
  };

  // Функция для обновления стоимости доставки
  const updateDeliveryPrice = (selectedCity, currentTotal) => {
    const cityName = cities.find(city => city.id === selectedCity)?.name || '';
    const deliveryProduct = getProductByName(`Доставка - ${cityName}`);
    let newDeliveryPrice = deliveryProduct ? deliveryProduct.price : 0;

    if ((cityName === "Верхний Тагил" && currentTotal > 2500) ||
        (cityName === "Кировград" && currentTotal > 500) ||
        (cityName === "Невьянск" && currentTotal > 2500) ||
        (cityName === "Лёвиха" && currentTotal > 4000) ||
        (cityName === "Н-рудянка" && currentTotal > 2500) ||
        (cityName === "Цементный" && currentTotal > 2000) ||
        (cityName === "Шурала" && currentTotal > 2000) ||
        (cityName === "Карпушиха" && currentTotal > 3000)) {
        newDeliveryPrice = 0; // Доставка бесплатная
    }

    setDeliveryPrice(newDeliveryPrice);
  };

  // СТАТУС ПОСЛЕДНИХ ЗАКАЗОВ
  const getStatusText = (status) => {
    switch (status) {
      case "Closed":
        return "Доставлен";
      case "Cancelled":
        return "Отменен";
      case "ReadyForCooking":
        return "Ожидает подтверждения";
      default:
        return status || "Неизвестно";
    }
  };

  useEffect(() => {
    if (addressData.city) {
        updateDeliveryPrice(addressData.city, totalPrice);
    }
  }, [cart, totalPrice]);

  return (
    <header>
      <div className="header__content">
        <div>
          <a href="/"><img className="header__logo" src={logo} alt="Логотип" /></a>
        </div>
        <div className="header__contact">
          <p className="header__time header__hide">{currentTime}</p>
          <a className="header__phone" href="tel:+79226002900">&#x1F4DE; <p className='header__hide'>+792-2600-2900</p></a>
        </div>
        <div className="header__menu">
          {user ? (
            <div className="header__menu-item" onClick={toggleUserMenu}>
              <img className='header__menu-item-image' src={icon} alt='Личный кабинет' />
                {showUserMenu && (
                  <div className="header__dropdown-menu">
                    <button className="header__dropdown-item" onClick={openUserProfilePopup}>
                      Профиль
                    </button>
                    <button className="header__dropdown-item" onClick={openOrderHistoryPopup}>
                      История заказов
                    </button>
                    <button className="header__dropdown-item" onClick={onOpenFeedback}>
                      Обратная связь
                    </button>
                  </div>
                )}
            </div>
          ) : (
            <div className="header__menu-item" onClick={openLoginPopup}>Войти</div>
          )}
          <button className="header__menu-item" onClick={openCartPopup}>
            <div className="header__basket-wrapper">
              <img className="header__basket" src={basket} alt="Корзина"/>
            </div>
            <p>{totalPrice + deliveryPrice}₽</p>
          </button>
        </div>
      </div>

      {showLoginPopup && (
        <PopupLogin
          formData={formData}
          errorMessage={errorMessage}
          showCodeInput={showCodeInput}
          timer={timer}
          maskedEmail={maskedEmail}
          verificationCode={verificationCode}
          onChange={handleChange}
          onSubmit={handleLoginSubmit}
          onVerificationCodeChange={setVerificationCode}
          onOpenRegistration={openRegistrationPopup}
          onVerifyCode={verifyCode}
          onClose={closePopups}
        />
      )}

      {showRegistrationPopup && (
        <PopupRegistration
          formData={formData}
          errorMessage={errorMessage}
          onChange={handleChange}
          onSubmit={handleUserProfileSubmit}
          onOpenConsent={openConsentPopup}
          onClose={closePopups}
        />
      )}

      {showConsentPopup && <PopupConsent onClose={() => setShowConsentPopup(false)} />}

      {showUserProfilePopup && (
        <PopupUserProfile
          formData={formData}
          onChange={handleChange}
          onSubmit={handleUserProfileSubmit}
          onClose={closePopups}
          onLogout={handleLogout}
        />
      )}

      {showOrderHistoryPopup && (
        <PopupOrderHistory
          loadingOrders={loadingOrders}
          orderError={orderError}
          orderHistory={orderHistory}
          getStatusText={getStatusText}
          onClose={closeOrderHistoryPopup}
        />
      )}

      {showCartPopup && (
        <PopupCart
          user={user}
          formData={formData}
          addressData={addressData}
          cities={cities}
          allStreets={allStreets}
          cart={cart}
          totalPrice={totalPrice}
          deliveryPrice={deliveryPrice}
          pizzaBoxes={pizzaBoxes}
          setFormData={setFormData}
          setAddressData={setAddressData}
          setCartData={setCartData}
          handleCityChange={handleCityChange}
          handleStreetSearch={handleStreetSearch}
          handleOrderSubmit={handleOrderSubmit}
          openLoginPopup={openLoginPopup}
          closePopups={closePopups}
          increaseItemAmount={increaseItemAmount}
          decreaseItemAmount={decreaseItemAmount}
          removeItem={removeItem}
        />
      )}
      {showOrderSuccessPopup && (
        <PopupOrderSuccess
          onClose={() => setShowOrderSuccessPopup(false)}
          onOpenFeedback={onOpenFeedback}
        />
      )}
    </header>
  );
}

export default Header;
